import React from "react";
import RelatedArticles from "../components/RelatedArticles";
import AuthorBio from "../components/AuthorBio";
import References from "../components/References";
import { useArticlesContext } from "../context/ArticlesContext";

const Bottom = (props) => {

  return (
    <>
        <References
            referencesData={props.referencesData}
        />
        <AuthorBio/>

        {props.ref_data && (
            <RelatedArticles referenceArticle={props.ref_data} />
        )}
    </>
  );
};

export default Bottom;